import { useEffect } from "react";
import { useLocation } from "react-router-dom";

declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & { callMethod?: (...args: unknown[]) => void; queue?: unknown[]; push?: unknown; loaded?: boolean; version?: string };
    _fbq?: unknown;
  }
}

export const META_PIXEL_ID = "957503137377766";

/** Marketing consent from the cookie banner ("cookie-consent" in localStorage). */
export function hasMarketingConsent(): boolean {
  if (typeof window === "undefined") return false;
  try {
    const raw = localStorage.getItem("cookie-consent");
    if (!raw) return false;
    return Boolean((JSON.parse(raw) as { marketing?: boolean }).marketing);
  } catch {
    return false;
  }
}

let initialised = false;

/** Load the Meta Pixel base code once, but only with marketing consent. */
export function initMetaPixel() {
  if (typeof window === "undefined" || initialised) return;
  if (!hasMarketingConsent()) return;

  /* eslint-disable */
  (function (f: any, b: Document, e: string, v: string) {
    if (f.fbq) return;
    const n: any = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    });
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = "2.0";
    n.queue = [];
    const t = b.createElement(e) as HTMLScriptElement;
    t.async = true;
    t.src = v;
    const s = b.getElementsByTagName(e)[0];
    s.parentNode?.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  /* eslint-enable */

  initialised = true;
  window.fbq?.("init", META_PIXEL_ID);
  window.fbq?.("track", "PageView");
}

/** Track a Meta Pixel PageView on client-side route changes. */
export function useMetaPixelPageView() {
  const location = useLocation();

  useEffect(() => {
    if (!initialised) {
      initMetaPixel();
      return; // init already sends the first PageView
    }
    window.fbq?.("track", "PageView");
  }, [location.pathname, location.search]);
}

/** Fire the standard Lead event (quote form / calculator completed). */
export function trackMetaLead(params: Record<string, unknown> = {}) {
  if (typeof window === "undefined") return;
  if (!initialised) initMetaPixel();
  window.fbq?.("track", "Lead", params);
}
